import React, { Component } from 'react';
import throttle from 'lodash/throttle';
import cx from 'classnames';
import MediaQueries from 'react-responsive';

import Align from '@marvelapp/marvel-ui/align';
import Grid, { GridItem, InlineGrid } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import DevLogo from './DevLogo';
import DevMobileNav from './DevMobileNav';
import DevSubNav from './DevSubNav';
import HeaderButton from './HeaderButton';
import HeaderNav from './HeaderNav';

import generalStyles from './style/general.module.css';

class DevHeader extends Component {
  constructor() {
    super();

    this.state = {
      isNavOpen: false,
      hasScrolled: false,
      isMobileNavOpen: false,
    };

    this.toggleNav = this.toggleNav.bind(this);
    this.handleScroll = throttle(this.handleScroll.bind(this), 50);
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (window.scrollY > 5) {
      this.setState({ hasScrolled: true });
    } else {
      this.setState({ hasScrolled: false });
    }
  }

  toggleNav() {
    const { isNavOpen } = this.state;
    this.setState({ isNavOpen: !isNavOpen });
  }

  toggleMobileNav() {
    const { isMobileNavOpen } = this.state;
    this.setState({ isMobileNavOpen: !isMobileNavOpen });
  }

  render() {
    const { hasScrolled } = this.state;

    const headerClassName = cx(generalStyles.header, {
      [generalStyles.default]: !hasScrolled,
      [generalStyles.hasScrolled]: hasScrolled,
    });

    return (
      <div>
        <header className={headerClassName}>
          <MediaQueries maxWidth={919}>
            <Spacing type="padding" position="left" size="xs">
              <DevLogo />
            </Spacing>
          </MediaQueries>
          <PageWrap maxWidth={1016}>
            <MediaQueries minWidth={920}>
              <Grid columns={12} alignItems="center">
                <GridItem columnSpan={3}>
                  <DevLogo />
                </GridItem>
                <GridItem columnSpan={9}>
                  <Align type="right">
                    <InlineGrid size="l">
                      <HeaderNav isLight />
                      <HeaderButton
                        title="My Applications"
                        url="https://marvelapp.com/oauth/applications/"
                      />
                    </InlineGrid>
                  </Align>
                </GridItem>
              </Grid>
            </MediaQueries>
          </PageWrap>
        </header>
        <MediaQueries maxWidth={769}>
          <DevSubNav hasScrolled={this.state.hasScrolled} />
        </MediaQueries>
        <MediaQueries maxWidth={919}>
          <DevMobileNav
            hasScrolled={this.state.hasScrolled}
            isOpen={this.state.isMobileNavOpen}
            toggleNav={() => this.toggleMobileNav()}
          />
        </MediaQueries>
      </div>
    );
  }
}

export default DevHeader;



// WEBPACK FOOTER //
// ./src/components/modules/DevHeader/index.js